const initHeroBlock = () => {
    // Select the elements for animation
    const hero = document.querySelector('.js-hero');
    const videoElement = hero.querySelector('video'); // Adjust the selector if necessary
    const opacityElement = hero.querySelector('.js-hero-opacity'); // Adjust the selector if necessary

    // Disable scrolling by preventing scroll-related events
    function disableScroll() {
        isScrollBlocked = true;
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventScroll, { passive: false });
        window.addEventListener('keydown', preventScrollKeys, { passive: false });
    }

    // Enable scrolling by removing event listeners
    function enableScroll() {
        isScrollBlocked = false;
        window.removeEventListener('wheel', preventScroll);
        window.removeEventListener('touchmove', preventScroll);
        window.removeEventListener('keydown', preventScrollKeys);
    }

    // Prevent default behavior for scroll-related events
    function preventScroll(e) {
        e.preventDefault();
    }

    // Prevent default behavior for keyboard scrolling (arrows, space, page up/down)
    function preventScrollKeys(e) {
        const keys = [32, 33, 34, 35, 36, 37, 38, 39, 40]; // Space, page up/down, arrow keys
        if (keys.includes(e.keyCode)) {
            e.preventDefault();
        }
    }

    document.addEventListener('scroll', () => {
        
        const heroRect = hero.getBoundingClientRect();
        
        // Total scrollable area for the sticky section within the hero
        const totalScrollableSpace = heroRect.height - window.innerHeight;
  
        // Calculate how much space has been scrolled as a percentage of the total
        const scrolledSpace = -heroRect.top; // Distance scrolled within hero
        const scrollPercent = Math.min((scrolledSpace / totalScrollableSpace) * 100, 100);
  
        // Update classes on sticky section based on scroll percent of remaining space
        if (scrollPercent <= 30) {
            hero.classList.add('step-1');
            hero.classList.remove('step-2', 'step-3', 'animation');
            // disableScroll(); // Disable scroll temporarily
            // setTimeout(enableScroll, 1000); // Enable scroll after 1000ms
        } else if (scrollPercent > 30 && scrollPercent <= 60) {
            hero.classList.add('step-2');
            hero.classList.remove('step-1', 'step-3', 'animation');
            // disableScroll(); // Disable scroll temporarily
            // setTimeout(enableScroll, 1000); // Enable scroll after 1000ms
        } else {
            hero.classList.add('step-3');
            hero.classList.remove('step-1', 'step-2', 'animation');
            // disableScroll(); // Disable scroll temporarily
            // setTimeout(enableScroll, 1000); // Enable scroll after 1000ms
        }
    });
};

document.addEventListener('DOMContentLoaded', initHeroBlock, false)